// @flow
import { useTranslation } from 'react-i18next';

import ModalYesNo from '@shared/Modal/components/ModalYesNo/ModalYesNo';

type Props = {
  isActive: boolean,
  toggleModal: () => void,
  showSuccessMessage: (message: string) => void,
};

const ModalChangeTheStatusOfGroupClass = (props: Props): React$Node => {
  const { isActive, toggleModal, onClickYes } = props;

  const { t } = useTranslation();

  return (
    <ModalYesNo
      isActive={ isActive }
      toggleModal={ toggleModal }
      onClickYes={ onClickYes }
      title={ t('groupClasses.changeTheStatusGroupClassTitle') }
    >
      <p>
        { t('groupClasses.changeTheStatusGroupClass') }
      </p>
    </ModalYesNo>
  );
};

export default ModalChangeTheStatusOfGroupClass;
